<div class="modal">
    <div class="header">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="title title-big" *ngIf="isFileReaderError" translate>
            UPLOADER_MODAL_FATAL_UPLOAD_ERROR_FILE_READER_ERROR_TITLE
        </div>
        <div class="title title-big" *ngIf="isDropboxDisabledError" translate>
            UPLOADER_MODAL_FATAL_UPLOAD_ERROR_DROPBOX_DISABLED_ERROR_TITLE
        </div>
        <div class="title title-big" *ngIf="isUnknownError" translate>
            UPLOADER_MODAL_FATAL_UPLOAD_ERROR_UNKNOWN_ERROR_TITLE
        </div>
    </div>
    <div class="body">
        <div class="section">
            <div>
                <p *ngIf="isFileReaderError" translate [translateParams]="{name: errorDetails?.primary}">
                    UPLOADER_MODAL_FATAL_UPLOAD_ERROR_FILE_READER_ERROR_BODY
                </p>
                <p *ngIf="isDropboxDisabledError" translate>
                    UPLOADER_MODAL_FATAL_UPLOAD_ERROR_DROPBOX_DISABLED_ERROR_BODY
                </p>
                <p *ngIf="isUnknownError" translate>
                    UPLOADER_MODAL_FATAL_UPLOAD_ERROR_UNKNOWN_ERROR_BODY
                </p>
            </div>
            <br>
            <div *ngIf="errorId" class="error-id-container">
                <span>
                    <u>ErrorId</u> : {{ errorId }}
                    <!-- FIX ME -->
                    <!-- tooltip zIndex is set to 1051 to be above the NgNeat Dialog backdrop which is set to 1050 by default -->
                    <app-smash-copy-button [value]="errorId" [tooltipZindex]="1051"></app-smash-copy-button>
                </span>
            </div>
        </div>
    </div>
    <div class="footer">
        <button class="btn-new red" (click)="retry()" *ngIf="isFileReaderError || isUnknownError" translate>
            UPLOADER_MODAL_FATAL_UPLOAD_ERROR_RETRY_CTA_LABEL
        </button>
        <button class="btn-new red" (click)="retry()" *ngIf="isDropboxDisabledError" translate>
            UPLOADER_MODAL_FATAL_UPLOAD_ERROR_HOMEPAGE_CTA_LABEL
        </button>
    </div>
</div>